import React, { useCallback, useEffect } from 'react';
import styles from './index.module.sass';
import PageLayout from 'layout/page';
import qs from 'query-string';
import Button from 'components/button';
import {
  useCreditCardContext,
  CHANGE_CVC,
  CHANGE_EXPIRE_DATE,
  CHANGE_PAN,
  SHOW_LOADING_COVER,
} from './use-credit-card';
import { useMochiPayFlowContext } from 'feature/mochi-pay-flow/use-mochi-pay-flow';
import { PATH } from 'config';
import BindCardForm from 'module/bind-card-form';
import amplitude from 'service/amplitude';
import { useLocation } from 'react-router-dom';
import { useAppContext } from 'use-app';

const MochiPayCreditCard = React.memo(() => {
  const { state, dispatch, bindCard, bindCardFormButtonRef } = useCreditCardContext();
  const { createWallet, bindCreditCardFail } = useMochiPayFlowContext();
  const { state: appState } = useAppContext();
  const location = useLocation();

  useEffect(() => {
    if (window.location.hash !== '' && !appState.bindingIsSetted) {
      dispatch({ type: SHOW_LOADING_COVER, payload: true });
      const data = qs.parse(window.location.hash);
      const search = window.location.search ? qs.parse(window.location.search) : null;
      // result 代表這次綁卡成功與否 success: 成功, fail 失敗
      if (data.result === 'success') {
        createWallet(
          data['token'],
          data['merchant_transaction_id'],
          () => {
            dispatch({ type: SHOW_LOADING_COVER, payload: false });
          },
          search
        );
      } else {
        bindCreditCardFail(data.message, () => dispatch({ type: SHOW_LOADING_COVER, payload: false }), search);
      }
    }
  }, [appState.bindingIsSetted]); //eslint-disable-line

  const onChangePan = useCallback(
    value => {
      dispatch({
        type: CHANGE_PAN,
        payload: value,
      });
    },
    [dispatch]
  );

  const onFocusPan = () => amplitude.payment_addCard_cardNumber_onClick();

  const onChangeExpireDate = useCallback(
    value => {
      dispatch({
        type: CHANGE_EXPIRE_DATE,
        payload: value,
      });
    },
    [dispatch]
  );

  const onFocusExpireDate = () => amplitude.payment_addCard_expireDate_onClick();

  const onChangeCVC = useCallback(
    value => {
      dispatch({
        type: CHANGE_CVC,
        payload: value,
      });
    },
    [dispatch]
  );

  const onFocusCVC = () => amplitude.payment_addCard_cvc_onClick();

  const onBindCardClick = () => {
    amplitude.payment_addCard_confirm_onClick();
    bindCard();
  };

  if (state.loadingCover) {
    return <div className={styles['loading-cover']}>信用卡綁定中</div>;
  }

  const callbackUrl = () => {
    if (location.state) {
      return `https://${window.location.host}${PATH.MOCHIPAY_FLOW_CREDIT_CARD}?originPath=${location.state?.originPath}&searchName=${location.state?.searchName}&searchContent=${location.state?.searchContent}`;
    } else {
      return `https://${window.location.host}${PATH.MOCHIPAY_FLOW_CREDIT_CARD}`;
    }
  };

  return (
    <PageLayout theme="form">
      <div className={styles['mochi-pay-credit-card']}>
        <div className={styles.top}>
          <BindCardForm
            ccNumber={state.pan}
            ccNumberErrorMessage={state.panError}
            onCcNumberChange={onChangePan}
            onCcNumberFocus={onFocusPan}
            ccExpireDate={state.expireDate}
            ccExpireDateErrorMessage={state.expireDateError}
            onCcExpireDateChange={onChangeExpireDate}
            onCcExpireDateFocus={onFocusExpireDate}
            ccCVC={state.cvc}
            ccCVCErrorMessage={state.cvcError}
            onCcCVCChange={onChangeCVC}
            onCcCVCFocus={onFocusCVC}
            merchantUid={state.merchantUid}
            transactionId={state.transactionId}
            callbackUrl={callbackUrl()}
            hiddenFormButtonRef={bindCardFormButtonRef}
          />
        </div>
        <div className={styles.bottom}>
          <Button theme="blue" block={true} loading={state.loading} onClick={onBindCardClick}>
            設定好了
          </Button>
        </div>
      </div>
    </PageLayout>
  );
});

export default MochiPayCreditCard;
